<template lang="pug">
el-dialog(
  :title="title",
  width="95%",
  :visible.sync="visible",
  :modal-append-to-body="false",
  :append-to-body="true"
)
  el-form(
    :model="ruleForm",
    :inline="false",
    :rules="rules",
    ref="ruleForm",
    label-width="130px"
  )
    el-card(shadow="never")
      div
        el-form-item(label="比赛ID:", prop="matchId")
          font {{ ruleForm.matchId }}
        el-form-item(label="比赛名称:", prop="matchName")
          font {{ ruleForm.matchName }}
        el-form-item(label="主办方:", prop="createUserInfoRealName")
          font {{ ruleForm.createUserInfoRealName }}
        el-form-item(label="主办城市:", prop="cityName")
          font {{ ruleForm.provinceName }}&nbsp;{{ ruleForm.cityName }}
        el-form-item(label="比赛场地:", prop="venueAddress")
          font {{ ruleForm.venueAddress }} &nbsp;&nbsp;&nbsp;地址: {{ ruleForm.venueAddress }}
        el-form-item(label="比赛类型:", prop="projectType" v-if="ruleForm.matchType==3")
          //- font(v-if="ruleForm.ctType === 5") 月度赛-资格赛
          //- font(v-if="ruleForm.ctType === 6") 月度赛-级别赛
          //- 全局搜索,替换
          font(v-if="ruleForm.projectType === 1") 单打
          font(v-if="ruleForm.projectType === 2") 双打
        el-form-item(label="签位:", prop="applySize")
          font {{ ruleForm.applySize }}
        el-form-item(label="第一阶段赛制:")
          font {{ CompetitionSelection(ruleForm.firstFormat, 1) }}&nbsp;&nbsp;&nbsp; 组数：{{ ruleForm.groupNum }}
        el-form-item(label="第二阶段赛制:")
          font {{ CompetitionSelection(ruleForm.secondFormat, 2) }}&nbsp;&nbsp;&nbsp; 交叉数：{{ ruleForm.crossNum }}
        el-form-item(label="级别:", prop="level")
          font {{ ruleForm.level.split(",")[0] }} ~ {{ ruleForm.level.split(",")[1] }}
        el-form-item(label="报名时间:", prop="applyDate")
          font {{ ruleForm.matchSignStartTime }}&nbsp;至&nbsp;{{ ruleForm.matchSignEndTime }}
        el-form-item(label="比赛时间:", prop="matchStartTime")
          font {{ ruleForm.matchStartTime }}
        //- el-form-item(label="比赛简介:" prop="matchDescription")
        //-     div(v-html='ruleForm.matchDescription')
        el-form-item(label="报名须知:", prop="matchDescription")
          font {{ ruleForm.matchDescription }}
    br

    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 报名费用
      div
        el-form-item(label="报名费:", prop="gameDescription")
          font {{ ruleForm.entryFee }}

    br
    el-card(shadow="never", v-if="type == 'release'")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 审核意见
      div
        el-form-item(prop="verifyReason", label="填写审核意见:")
          el-input(
            v-model="ruleForm.verifyReason",
            type="textarea",
            :rows=5,
            resize="none"
          )

  span.dialog-footer(slot="footer", v-if="!type")
    el-button(@click="visible = false") 返 回
  //审核发布
  span.dialog-footer(slot="footer", v-if="type == 'release'")
    el-button(@click="releaseSubmit(2)", type="primary") 发 布
    el-button(@click="releaseSubmit(5)", type="danger") 拒 绝
    el-button(@click="visible = false") 取 消
  //- //支付弹窗组件
  zfpage(
    :openfree="visibleFee",
    :record="record",
    v-if="visibleFee",
    @zfsuccess="zfsuccess"
  )
</template>
<script>
import zfpage from "../zfpage.vue";
export default {
  components: {
    zfpage,
  },
  data() {
    return {
      visibleFee: false,
      record: {},
      type: "",
      title: "查看详情",
      tableData: [
        {
          dataName: "团队费用",
          price: 0.0,
        },
      ],
      defaultImg: "",
      listImageUrl: "",
      detailImageUrl: "",
      ruleForm: {
        id: null,
        ctId: "",
        matchName: "",
        orgId: "",
        city: "",
        province: "",
        placeId: "",
        ctType: "",
        applySize: "",
        applyDate: [],
        matchSignStartTime: "",
        matchSignEndTime: "",
        matchStartTime: "",
        imgList: "",
        presidentLimit: "",
        teamMin: "",
        teamMax: "",
        gameDescription: "",
        matchDescription: "",
        imgDetailList: "",
        repeatSign: "0",
        genderLimit: "2",
        ageLimit: "",
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: "",
        ctRefundList: [],
        byx1: "",
        verifyReason: "",
        competitionClub: {
          sixthMan: "",
        },
      },
      visible: false,
      rules: {
        // verifyReason: [
        //     { required: true, message: '审核意见不能为空!', trigger: 'blur' },
        //     { max: 200, message: '审核意见长度不能超过200个字符!' }
        // ]
      },
    };
  },
  methods: {
    zfsuccess(data) {
      this.visibleFee = false;
      console.log(data, 789);
      if (data == 1) {
        // this.$showLoading()
        this.$http({
          url: this.$http.adornUrl(`/frFranchiseFeeRecord/checkPayStatus`),
          method: "post",
          data: {
            busId: this.ruleForm.id,
            busType: 1,
            busCategory: 2,
          },
        }).then((data) => {
          if (data && data.code === 0) {
            this.visible = false;
            //缴费成功，直接发布
            this.updateState(2);
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    init(id, type) {
      this.title = "查看详情";
      this.ruleForm.id = id || null;
      this.visible = true;
      this.type = type;
      if (type === "release") {
        this.title = "审核发布";
        this.finachiseFeePay();
      }
      this.ruleForm.verifyReason = "";
      //回选
      if (this.ruleForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/getId/` + this.ruleForm.id),
          method: "get",
        }).then((data) => {
          if (data && data.code === 0) {
            this.ruleForm = data.bean;
            this.ruleForm.teamNum = data.bean.teamNum ? data.bean.teamNum : 16;
            if (this.ruleForm.competitionClub) {
              this.ruleForm.competitionClub.sixthMan = this.ruleForm
                .competitionClub.sixthMan
                ? 1
                : 0;
            } else {
              this.ruleForm.competitionClub = {
                sixthMan: -1,
              }; //默认是否第六人为1
            }
            this.listImageUrl = data.bean.imgUrlList;
            this.detailImageUrl = data.bean.imgUrlDetail;
            this.ruleForm.applyDate = [];
            this.ruleForm.applyDate.push(data.bean.matchSignStartTime);
            this.ruleForm.applyDate.push(data.bean.matchSignEndTime);
            this.ruleForm.ctRefundList = [];
            for (let i of data.eList) {
              for (let j of this.tableData) {
                j.price = i.price;
                break;
              }
            }
            this.ruleForm.verifyReason = "";
            if (data.bean.clubLimit) {
              this.ruleForm.clubLimit = data.bean.clubLimit.split(",");
            }
            let index = 1;
            for (let i of data.rList) {
              this.ruleForm.ctRefundList.push({
                index: index++,
                minDuration: i.minDuration,
                refundScale: i.refundScale,
              });
            }
          }
        });
      }
    },
    releaseSubmit(type) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (type === 2) {
            this.$confirm("是否发布比赛?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                // 迭代三调试暂时关闭功能，直接打开下面注释即可

                // //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
                // //status状态(0未缴费，1已缴费，2已退费)
                // if (this.record.type === 1 && this.record.status === 0) {
                //   //仅未支付预缴费时，展示二维码支付页面
                //   this.visibleFee = true
                // } else {
                //   //不是预缴费，则直接发布
                //   this.updateState(type)
                // }
                // 迭代三调试暂时关闭功能，直接注释即可下面
                this.updateState(type);
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消发布",
                });
              });
          } else if (type === 5) {
            this.updateState(type);
          }
        }
      });
    },
    //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
    finachiseFeePay() {
      this.$http({
        url: this.$http.adornUrl(`/frFranchiseFeeRecord/createQrCode`),
        method: "post",
        data: {
          busId: this.ruleForm.id,
          busType: 1,
          busCategory: 2,
        },
      }).then((data) => {
        if (data && data.code === 0) {
          this.record = data.record;
          console.log("record", this.record);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 数据处理
    CompetitionSelection(val, index) {
      // console.log(val)
      // console.log(val !== null && val !== '')

      if (val !== null && val !== "") {
        if (index == 1) {
          // return this.ruleForm.firstFormat !== null && this.ruleForm.firstFormat == 0
          //   ? "淘汰附加赛"
          //   : this.ruleForm.firstFormat !== null && this.ruleForm.firstFormat == 1
          //   ? "小组循环赛"
          //   : "";
          if (
            this.ruleForm.firstFormat !== null &&
            this.ruleForm.firstFormat == 0
          ) {
            return "淘汰附加赛";
          }

          if (
            this.ruleForm.firstFormat !== null &&
            this.ruleForm.firstFormat == 1
          ) {
            return "小组循环赛";
          }

          if (
            this.ruleForm.firstFormat !== null &&
            this.ruleForm.firstFormat == 5
          ) {
            return "淘汰赛";
          }
        }
        if (index == 2) {
          return this.ruleForm.secondFormat == 2 &&
            this.ruleForm.firstFormat != 5
            ? "同名次小组循环赛"
            : this.ruleForm.secondFormat == 3 && this.ruleForm.firstFormat != 5
            ? "同名次淘汰附加赛"
            : this.ruleForm.secondFormat == 4 && this.ruleForm.firstFormat != 5
            ? "交叉淘汰附加赛"
            : "";
        }
      } else {
        return "";
      }
    },
    updateState(type) {
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/updateStatus`),
        method: "post",
        params: this.$http.adornParams({
          status: type,
          id: this.ruleForm.id,
          verifyReason: this.ruleForm.verifyReason,
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({
            message: "审核成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              this.visible = false;
              this.$emit("refreshDataList");
            },
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
  },
};
</script>
<style>
.comecs .el-form-item__content {
  display: flex;
}
/* 比赛简介 */
p {
  margin: 0;
}
</style>
